import Image from 'next/image';
import classes from './MarketingEmailList.module.scss';
import Link from 'next/link';

export default function MarketingEmailList(props) {
    if (!props) return null;
    const marketingEmails = props[1].marketing_email_list;

    return (
        <div className={classes.oMarketingEmails}>
            {marketingEmails.map((item) => (
                <div className={classes.mContactLine} key={item.id}>
                    {/* <h3 className={`${classes.aTitle} fnt24l`}>{item.title}</h3> */}
                    <p className={`${classes.aText} fnt16f fontRTL`}>{item.title}</p>
                    <br />
                    <span className={classes.aContactIcon}>
                        <Image
                            src="/web/images/icon-envelope.svg"
                            alt="envelope"
                            width={25}
                            height={25}
                            layout="responsive"
                        />
                    </span>
                    <Link className={`${classes.aText} fnt16f`} href="">
                        <a href={`mailto:${item.email}`} className={classes.aLinkText}>
                            {item.email}
                        </a>
                    </Link>
                </div>
            ))}
        </div>
    );
}
